import { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import Logo from "@/components/Logo";
import SupportWidget from "@/components/SupportWidget";
import VerifyBanner from "@/components/VerifyBanner";
import ProductTour from "@/components/ProductTour";
import NewUserSimBanner from "@/components/NewUserSimBanner";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AppShell() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background text-foreground flex">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex fixed inset-y-0 left-0 w-64 border-r border-border bg-background z-40">
        <Sidebar onNavigate={() => setOpen(false)} />
      </aside>

      {/* Mobile top bar */}
      <header
        className="lg:hidden fixed top-0 inset-x-0 h-14 z-40 flex items-center justify-between px-4 border-b border-border bg-background/85 backdrop-blur-xl"
        data-testid="mobile-topbar"
      >
        <Logo variant="name" height={44} to="/app" testid="mobile-logo" />
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menü umschalten"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </Button>
      </header>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-foreground/20 backdrop-blur-[2px]"
            onClick={() => setOpen(false)}
            data-testid="mobile-menu-scrim"
          />
          <aside className="absolute inset-y-0 left-0 w-72 max-w-[85%] bg-background border-r border-border">
            <Sidebar onNavigate={() => setOpen(false)} />
          </aside>
        </div>
      )}

      <main className="flex-1 min-w-0 lg:pl-64 flex flex-col" data-testid="main-content">
        <NewUserSimBanner />
        <Topbar />
        <div className="pt-14 lg:pt-0 flex-1">
          <div className="max-w-[1240px] mx-auto px-5 md:px-10 py-8 md:py-12">
            <VerifyBanner />
            <Outlet />
          </div>
        </div>
        <footer
          className="border-t border-border mt-auto"
          data-testid="app-footer"
        >
          <div className="max-w-[1240px] mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
            <div>© {new Date().getFullYear()} TradeMind · Intelligence Platform</div>
            <div className="flex items-center gap-5">
              <Link to="/app/impressum" className="hover:text-foreground transition-colors" data-testid="footer-imprint">
                Impressum
              </Link>
              <Link to="/app/datenschutz" className="hover:text-foreground transition-colors" data-testid="footer-privacy">
                Datenschutz
              </Link>
              <Link to="/app/agb" className="hover:text-foreground transition-colors" data-testid="footer-terms">
                AGB
              </Link>
            </div>
          </div>
        </footer>
      </main>
      <SupportWidget />
      <ProductTour />
    </div>
  );
}
